function e(r) {
  return function(n) {
    return r == null ? void 0 : r[n];
  };
}
var t = e;
export {
  t as _
};
//# sourceMappingURL=_basePropertyOf.js.map
